import type { ReactNode, ReactElement } from 'react';

import { motion } from 'framer-motion';
// material
import { Box } from '@mui/material';
//
import { varSmallClick, varMediumClick } from './variants';

export interface ButtonAnimateProps {
  mediumClick?: boolean;
  children?: ReactNode;
  sx?: Record<string, any>;
  [key: string]: any;
}

// ----------------------------------------------------------------------

export default function ButtonAnimate({
  mediumClick = false,
  children,
  sx,
  ...other
}: ButtonAnimateProps) {
  return (
    <Box
      component={motion.div}
      whileTap="tap"
      whileHover="hover"
      variants={mediumClick ? varMediumClick : varSmallClick}
      sx={{ display: 'inline-flex', ...sx }}
      {...other}
    >
      {children}
    </Box>
  );
}
